import { Component } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { EmailsFormComponent } from '../../../forms/standard/emails-form/emails-form.component';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ReviewUsersSectionsTableComponent } from '../review-users-sections-table/review-users-sections-table.component';
import { GenerateEmailsUsersFormComponent } from '../../../forms/standard/generate-emails-users-form/generate-emails-users-form.component';
import { EmailName } from '@mira-avant/mtlibs';

enum GenerateEmailUsersPageState {
	//Text area to paste emails - one per line
	SUBMIT_EMAILS = 'SUBMIT_EMAILS',
	//Give the admin the ability to clear previously assigned sections
	REVIEW_EXISTING_USERS = 'REVIEW_EXISTING_USERS',
	//Select the sections and groups to assign to the users
	CREATE_EMAIL_USERS = 'CREATE_EMAIL_USERS',
	//When we're all done
	FINISHED = 'FINISHED',
}

interface EmailsPayload {
	emails: string;
}

@Component({
	selector: 'app-generate-email-users',
	standalone: true,
	imports: [
		AngularModule,
		EmailsFormComponent,
		ZorroModule,
		ReviewUsersSectionsTableComponent,
		GenerateEmailsUsersFormComponent,
	],
	templateUrl: './generate-email-users.component.html',
	styleUrl: './generate-email-users.component.scss',
})
export class GenerateEmailUsersComponent {
	public state: GenerateEmailUsersPageState = GenerateEmailUsersPageState.SUBMIT_EMAILS;
	public GenerateEmailUsersPageState = GenerateEmailUsersPageState;
	public loading: boolean = false;
	public emails: EmailName[] = [];

	public async onSubmitEmails$(emails: EmailsPayload): Promise<void> {
		//emails comes in like: john.doe@example.com, John, Doe one per line
		//with optional first and last names
		this.emails = emails.emails.split('\n').map(email => {
			const parts = email.split(',').map(part => part.trim());
			return {
				email: parts[0],
				firstName: parts[1] || undefined,
				lastName: parts[2] || undefined,
			};
		});

		this.state = GenerateEmailUsersPageState.REVIEW_EXISTING_USERS;
	}

	public showCreateNewUsers(): void {
		this.state = GenerateEmailUsersPageState.CREATE_EMAIL_USERS;
	}

	public showFinished(): void {
		this.state = GenerateEmailUsersPageState.FINISHED;
	}
}
